import { render, staticRenderFns } from "./WhatsNew.vue?vue&type=template&id=59cd64b6&scoped=true&"
import script from "./WhatsNew.vue?vue&type=script&lang=js&"
export * from "./WhatsNew.vue?vue&type=script&lang=js&"
import style0 from "./WhatsNew.vue?vue&type=style&index=0&id=59cd64b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cd64b6",
  null
  
)

export default component.exports